module.exports = __webpack_public_path__ + "static/media/STAF_bokmål_sentrert logo_pos(svart).d470569e.svg";